import axios from 'axios';

const isProduction = process.env.NODE_ENV === 'production';

export const getEnv = () => {
  return {
    isProduction,
    isDev: !isProduction,
  };
};

export const getBaseUrl = () => {
  const env = getEnv();
  console.log('ENVIRONMENTS', env);
  // if (env.isProduction) return 'https://app.amzwatcher.com';
  // return 'http://localhost:5000';
  // hardcoding prod because this is not served locally
  return 'https://app.amzwatcher.com';
};

const BASE_API_URL = `${getBaseUrl()}/api/`;

const Instance = axios.create({
  baseURL: BASE_API_URL,
  timeout: 1000000,
});

// const getUserId = () => localStorage.getItem('userId');

// Instance.interceptors.request.use(
//     config => {
//         config.headers['userid'] = getUserId();
//         // console.log('attached header', getToken());
//         return config;
//     },
//     error => {
//         Promise.reject(error);
//     },
// );

export default Instance;
